exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lazy-image-gallery[data-v-1a612016]{margin:2rem 0}.thumb[data-v-1a612016]{margin-bottom:1rem}.img-thumbnail[data-v-1a612016]{max-width:100%;height:auto;cursor:pointer;-webkit-transition:opacity .3s ease;transition:opacity .3s ease}.img-thumbnail[data-v-1a612016]:hover{opacity:.8}.spinner-border[data-v-1a612016]{width:2rem;height:2rem}.section-title[data-v-1a612016]{margin-bottom:1.5rem}@media (max-width:768px){.col-xs-6[data-v-1a612016]{width:50%;float:left}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a612016","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/Common/LazyImageGallery.vue
// module id = 2566
// module chunks = 1